import { Button, Modal, Paper, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useState } from 'react'
import { rollbackTask } from '../common/functions'

export default function TaskRollbackModal({ task, disabled }) {
  const [rollbackModalOpen, setRollbackModalOpen] = useState(false)
  const [rollbackMesage, setRollbackMessage] = useState('')

  if (!task.type?.isCancellable) {
    return <></>
  }

  return (
    <>
      <Button
        onClick={() => setRollbackModalOpen(true)}
        variant="contained"
        color="error"
        disableElevation
        disabled={disabled}
      >
        Вернуть
      </Button>
      <Modal
        open={rollbackModalOpen}
        onClose={() => setRollbackModalOpen(false)}
      >
        <Paper
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '400px',
            padding: '1rem',
            borderRadius: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}
        >
          <Typography variant="h6" component="h2">
            Подтверждение
          </Typography>
          <small>Подтвердите возвращение предыдущей задачи в работу</small>
          <TextField
            value={rollbackMesage}
            onChange={(e) => setRollbackMessage(e.target.value)}
            multiline
            label="Введите сообщение"
            minRows={5}
          />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            gap={3}
          >
            <Button
              onClick={() => setRollbackModalOpen(false)}
              variant="contained"
              color="primary"
              disabled={disabled}
            >
              Отмена
            </Button>
            <Button
              onClick={() =>
                rollbackTask({
                  paidServiceId: task.paidServiceId,
                  id: task.id,
                  message: rollbackMesage
                })
              }
              variant="contained"
              disabled={disabled}
              color="error"
            >
              Вернуть
            </Button>
          </Box>
        </Paper>
      </Modal>
    </>
  )
}
